export default "__VITE_ASSET__VC0D238X__"